import './header.css'

export default function LogoHeader() {
  return (
    <div className="logo-header-wrapper">
      <img
        className="tft-logo"
        src="https://cmsassets.rgpub.io/sanity/images/dsfx7636/news/983f5809c923f0ed400cea0d31d01dca8b1b16f9-368x118.svg?auto=format&fit=fill&q=80&w=368"
        alt="Teamfight Tactics Logo"
      />
    </div>
  )
}
